module.exports = __webpack_public_path__ + "img/186.toilets.6ba63d8d.svg";